import React from "react";
import { cn } from "../../../common/u1/cn";

/* The heading block every section sits under. */
export const EditStepHeader = ({
  step,
  totalSteps,
  groupTitle,
  title = "Complete Your Company Profile",
  intro = "Tell buyers, banks and partners who you are. Verified fields are confirmed by TREVEX and can't be edited.",
  className = "",
}) => (
  <header className={cn("max-w-[640px]", className)}>
    <p className="m-0 text-[11.5px] font-bold uppercase tracking-[0.13em] text-[var(--coral)] font-sans">
      Step {step} of {totalSteps}
      {groupTitle ? (
        <>
          {" · "}
          {groupTitle}
        </>
      ) : null}
    </p>

    <h1 className="mb-0 mt-2 text-[26px] font-bold leading-[1.2] text-[var(--ink)] font-sans sm:text-[30px]">
      {title}
    </h1>

    {intro && (
      <p className="mb-0 mt-2.5 text-[13.5px] leading-[1.55] text-[var(--muted)] font-sans">
        {intro}
      </p>
    )}
  </header>
);

export default EditStepHeader;
